/**
 * UTC ISO 8601 strings (`…Z`) for report date ranges — canonical form for state,
 * Redux, and API. Parse to `Date` only at UI boundaries (pickers, Intl).
 */
import { formatRangeForSavingsApi } from './reportDatePresets';

export function parseUtcIsoToDate(iso: string): Date {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) {
        throw new TypeError(`Invalid UTC ISO datetime string: ${iso}`);
    }
    return d;
}

export function normalizeSavingsRangeToApiIso(
    fromIso: string,
    toIso: string,
): { dateFrom: string; dateTo: string } {
    return formatRangeForSavingsApi({
        from: parseUtcIsoToDate(fromIso),
        to: parseUtcIsoToDate(toIso),
    });
}
